<template>
  <v-dialog
    v-if="request"
    :value="value"
    width="75vw"
    max-width="1200px"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        申請詳細情報
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-layout column mb-4>
            <v-flex class="label">申請種別</v-flex>
            <v-flex class="value"><Type :type="request.requestType"/></v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">代理店名</v-flex>
            <v-flex class="value">{{ request.agencyName }}</v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">マージン率</v-flex>
            <v-flex class="value"
              ><AppPercent :value="request.marginValue"
            /></v-flex>
          </v-layout>
          <template v-if="request.agencyMargin">
            <v-layout column mb-4>
              <v-flex class="label">使用可能期間</v-flex>
              <v-flex class="value">
                <v-layout class="label">
                  申請内容
                </v-layout>
                <v-layout>
                  <AppPeriod
                    :start="request.startDate"
                    :end="request.endDate"
                    is-date
                  />
                </v-layout>
                <v-layout class="label">
                  現在の設定
                </v-layout>
                <v-layout>
                  <AppPeriod
                    :start="request.agencyMargin.startDate"
                    :end="request.agencyMargin.endDate"
                    is-date
                  />
                </v-layout>
              </v-flex>
            </v-layout>
            <HistoryTable :items="request.agencyMargin.requests" />
          </template>
          <template v-else>
            <v-layout column mb-4>
              <v-flex class="label">使用可能期間</v-flex>
              <v-flex class="value">
                <AppPeriod
                  :start="request.startDate"
                  :end="request.endDate"
                  is-date
                />
              </v-flex>
            </v-layout>
            <v-layout column mb-4>
              <v-flex class="label">申請者情報</v-flex>
              <v-flex class="value">
                <v-layout align-center ma-2>
                  <v-flex class="label" xs3>所属：</v-flex>
                  <v-flex class="value">{{
                    request.requestAccountBelongsTo
                  }}</v-flex>
                </v-layout>
                <v-layout align-center ma-2>
                  <v-flex class="label" xs3>申請者：</v-flex>
                  <v-flex class="value">{{
                    request.requestAccountName
                  }}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout column mb-4>
              <v-flex class="label">申請日時</v-flex>
              <v-flex class="value"
                ><AppDateTime :value="request.requestTime"
              /></v-flex>
            </v-layout>
          </template>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('input', false)">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Type from '@/components/Shared/Presentation/Request/Type'
import HistoryTable from './HistoryTable'

export default {
  name: 'DetailModal',
  components: { Type, HistoryTable },
  props: {
    value: Boolean,
    request: Object,
  },
  watch: {
    request(request) {
      if (request) {
        request.fetchAgencyMargin()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.value {
  font-size: 16px;
}
</style>
